var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 103,
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_395)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_395)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM60.6984 57.96C61.5184 54.024 62.5844 51.236 63.8964 49.514C65.2084 47.874 67.0944 46.972 69.4724 46.972C71.1124 46.972 72.2604 47.464 73.0804 48.284C73.9004 49.104 74.3104 50.498 74.3104 52.384C74.3104 53.204 74.2284 54.024 74.0644 54.926C73.9004 55.91 73.7364 56.894 73.5724 57.96C73.2444 59.6 72.8344 61.158 72.4244 62.552C72.0144 63.946 71.5224 65.176 70.8664 66.16C70.2104 67.226 69.3904 68.046 68.4064 68.62C67.4224 69.194 66.1924 69.44 64.7984 69.44C62.9124 69.44 61.6004 68.948 60.9444 67.964C60.2884 66.98 59.9604 65.668 59.9604 64.028C59.9604 62.306 60.2064 60.256 60.6984 57.96ZM77.9184 32.704H89.2344C89.4804 31.228 89.6444 29.916 89.6444 28.768C89.6444 26.8 89.2344 25.078 88.5784 23.684C87.8404 22.372 86.8564 21.224 85.6264 20.404C84.3964 19.584 83.0024 18.928 81.3624 18.518C79.7224 18.19 78.0004 17.944 76.1964 17.944C71.3584 17.944 67.4224 18.846 64.4704 20.65C61.4364 22.454 58.9764 24.914 57.1724 27.866C55.2864 30.818 53.8104 34.262 52.8264 38.116C51.7604 41.97 50.7764 45.906 49.9564 50.006C49.4644 52.302 49.0544 54.434 48.7264 56.566C48.3984 58.698 48.3164 60.748 48.3164 62.634C48.3164 64.766 48.4804 66.652 48.9724 68.456C49.4644 70.26 50.2024 71.736 51.3504 73.048C52.4164 74.36 53.8924 75.344 55.6964 76.082C57.5004 76.82 59.8784 77.148 62.6664 77.148C69.2264 77.148 74.3924 75.426 78.0824 71.9C81.7724 68.374 84.3144 63.208 85.7084 56.402C86.2004 54.106 86.4464 51.974 86.4464 49.842C86.4464 46.398 85.5444 43.61 83.8224 41.478C82.1004 39.346 79.2304 38.28 75.2944 38.28C72.6704 38.28 70.2924 38.772 68.3244 39.674C66.2744 40.576 64.6344 41.806 63.3224 43.282H63.1584L63.8144 40.412C64.2244 38.28 64.7164 36.312 65.2904 34.508C65.7824 32.704 66.4384 31.146 67.2584 29.834C67.9964 28.522 68.8984 27.538 70.0464 26.8C71.1124 26.062 72.4244 25.652 74.0644 25.652C75.5404 25.652 76.6064 26.062 77.2624 26.718C77.9184 27.374 78.2464 28.44 78.2464 29.752C78.2464 30.244 78.1644 30.654 78.1644 31.146C78.0824 31.638 78.0004 32.212 77.9184 32.704Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_395",
  x: -11,
  y: 0.94397,
  width: 120.644,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_395"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_395",
  result: "effect2_dropShadow_1_395"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_395",
  result: "effect3_dropShadow_1_395"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_395",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_395",
  x: 16.808,
  y: 17.944,
  width: 76.8364,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_395"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_395",
  result: "shape"
})))));
export default SvgRank16;